import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "@/lib/api";
import { Bell, ArrowRight } from "lucide-react";

export default function Announcements() {
  const [items, setItems] = useState([]);
  useEffect(() => { api.get("/announcements").then((r) => setItems(r.data)).catch(() => setItems([])); }, []);
  return (
    <section data-testid="announcements" className="bg-nkf-blue text-white">
      <div className="nkf-container py-12 md:py-16 grid grid-cols-1 lg:grid-cols-12 gap-8">
        <div className="lg:col-span-4">
          <div className="text-[11px] uppercase tracking-[0.3em] text-nkf-gold font-semibold">Federation Board</div>
          <h2 className="font-display text-3xl md:text-4xl mt-2">Latest Announcements</h2>
          <p className="text-white/70 mt-3 text-sm leading-relaxed">
            Official circulars, technical notifications and federation updates issued directly by the NKF Bharat Secretariat.
          </p>
          <Link to="/news" className="inline-flex items-center gap-1 mt-5 text-nkf-gold font-semibold hover:underline">
            View all updates <ArrowRight className="h-4 w-4" />
          </Link>
        </div>
        <ul className="lg:col-span-8 divide-y divide-white/10 border-y border-white/10">
          {items.map((a) => (
            <li key={a.id} className="py-4 flex items-start gap-4">
              <Bell className="h-5 w-5 text-nkf-gold mt-0.5 shrink-0" />
              <div className="flex-1">
                <div className="text-white">{a.text}</div>
                {a.link && (
                  <Link to={a.link} className="mt-1 inline-block text-[12px] uppercase tracking-widest text-nkf-gold hover:underline">
                    Read more →
                  </Link>
                )}
              </div>
            </li>
          ))}
          {!items.length && <li className="py-4 text-white/60">No announcements right now.</li>}
        </ul>
      </div>
    </section>
  );
}
